import { selector, atom } from "recoil";
import { faqs } from "../services/apiCalls";

export const faqRefresh = atom({
  key: "faqRefresh",
  default: ""
})

export const editFaqVal = atom({
  key: "editFaqVal",
  default: {}
})

export const createFaqModal = atom({
  key: "createFaqModal",
  default: false
})

export const editFaqModal = atom({
  key: "editFaqModal",
  default: false
})

export const faqEditor = atom({
  key: "faqEditor",
  default: ""
})

export const faq = selector({
  key: "faq",
  get: async ({ get }) => {
    try {
      const res = get(faqRefresh);
      console.log(res)
      const result = await faqs();
      return result.data || [];
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return [];
    }
  }
});